// thumbUrl — request a resized copy of one of our own /media uploads from the
// on-the-fly thumbnail endpoint (POST-processed + disk-cached server-side).
// Small UI (cards, row thumbs, photo strips) should use this instead of the
// full ~1920px file. External URLs (scraped CDN images) pass through unchanged,
// and the full-size view (lightbox) should keep using the original url.
//
//   <img src={thumbUrl(image.url, 480)} />   // ~480px wide copy
//
// Allowed widths mirror ALLOWED_W in apps/api/src/routes/media.ts: 240/480/600/800.
export const thumbUrl = (url, w = 800) =>
  (typeof url === "string" && url.startsWith("/media/"))
    ? `/api/media/thumb?p=${encodeURIComponent(url.slice(7))}&w=${w}`
    : url;
